// utils/buildStandardError.js

export const buildStandardError = ({
  source,
  type,
  message,
  status,
  detail,
}) => {
  const timestamp = new Date().toISOString();

  let finalMessage = message;

  if (type === "validation") {
    finalMessage = `Validation failed: ${message}`;
  } else if (type === "api") {
    switch (status) {
      case 400:
        finalMessage = "Bad Request: " + (message || "Invalid input.");
        break;
      case 401:
        finalMessage = "Unauthorized: Please log in again.";
        break;
      case 403:
        finalMessage = "Forbidden: You do not have access.";
        break;
      case 404:
        finalMessage = "Not Found: Resource does not exist.";
        break;
      case 500:
        finalMessage = "Server Error: Please try again later.";
        break;
      default:
        finalMessage = `API Error: ${message || `Status ${status}`}`;
    }
  } else if (type === "unknown") {
    finalMessage =
      "Unexpected error: " +
      (message + " " + source + " " + detail || "An unknown issue occurred.");
  }

  return {
    id: `${source}-${type}-${status || message || timestamp}`, // unique-ish
    source,
    type, // 'validation' | 'api' | 'unknown'
    message: finalMessage,
    rawMessage: message,
    status: status || null,
    detail: detail || null,
    timestamp,
  };
};
